import { useCallback } from 'react';
import { Preference } from '../../models/Preference';
import { useFetchMyContentPreferences } from './index';
import useCreateMyContentPreferences from './useCreateMyContentPreferences';

type UseAddPreferencesModal = (newPreference: Preference, preferenceIndex?: number) => void;

const useAddPreferencesModal = (onSuccessCallback: () => void, onErrorCallback: () => void): UseAddPreferencesModal => {
  const { data: preferences, isLoading } = useFetchMyContentPreferences();
  const { mutate } = useCreateMyContentPreferences();

  return useCallback(
    (newPreference: Preference, newPreferenceIndex?: number) => {
      if (isLoading) {
        return;
      }
      let preferencesToUpdate: Preference[] = [];
      if (preferences?.length) {
        preferencesToUpdate = preferencesToUpdate.concat(preferences);
      }
      if (newPreferenceIndex !== undefined) {
        preferencesToUpdate[newPreferenceIndex] = newPreference;
      } else {
        preferencesToUpdate = [newPreference, ...preferencesToUpdate];
      }

      mutate(preferencesToUpdate, {
        onSuccess: onSuccessCallback,
        onError: onErrorCallback,
      });
    },
    [mutate, preferences, isLoading]
  );
};

export default useAddPreferencesModal;
